module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-page"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('section', {
    staticClass: "notfound"
  }, [_c('img', {
    attrs: {
      "src": require("assets/404.png")
    }
  }), _c('div', {
    staticClass: "title"
  }, [_vm._v("NOT FOUND")]), _c('div', {
    staticClass: "content"
  }, [_c('h1', [_vm._v("頁面錯誤 你迷路了嗎")]), _c('div', {
    staticClass: "description"
  }, [_vm._v("您可以至"), _c('router-link', {
    attrs: {
      "to": {
        name: 'activity'
      }
    }
  }, [_vm._v("活動資訊")]), _vm._v("了解活動")], 1)]), _c('div', {
    staticClass: "btn-row"
  }, [_c('router-link', {
    staticClass: "btn ghost-btn",
    attrs: {
      "to": {
        name: 'ticketType'
      }
    }
  }, [_vm._v("購買票卷")]), _c('router-link', {
    staticClass: "btn ghost-btn",
    attrs: {
      "to": {
        name: 'selectArea'
      }
    }
  }, [_vm._v("察看座位圖")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f2c05ea"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/notFound.vue
// module id = 570
// module chunks = 1